import {useCallback} from 'react';

import {DmsDataGrid} from '@dms/shared';

import {Nullish, RequiredTestIdProps, suffixTestId} from 'shared/web';

import type {EagGridMaximization, QueryFilterObject} from 'features/eag-grid';

interface ActivityLogDataGridProps extends RequiredTestIdProps {
  maximization?: EagGridMaximization;
  orderId: string | Nullish;
}

export function ActivityLogDataGrid(props: ActivityLogDataGridProps) {
  const queryModifier = useCallback(
    (filter: QueryFilterObject) => ({
      ...filter,
      serviceOrderId: String(props.orderId),
    }),
    [props.orderId]
  );

  return (
    <DmsDataGrid
      maximization={props.maximization}
      autoHeight
      gridCode="activity-log-service-order"
      data-testid={suffixTestId('activityLog', props)}
      queryModifier={queryModifier}
    />
  );
}
